<template>
    <div class="py-6 text-gray-500 dark:text-gray-400">
<!--        <inertia-link
            class="text-lg font-bold text-gray-800 dark:text-gray-200"
            :href="$page.props.tenant ? route('tenant.dashboard', { tenant: $page.props.tenant.id }) : route('dashboard')"
        >
            <div class="px-6">
                &lt;!&ndash;                <application-logo/>&ndash;&gt;
                {{ $page.props.tenant ? $page.props.tenant.name : $page.props.app.name }}
            </div>
        </inertia-link>-->
        <ul>
            <sidebar-item v-if="can('view dashboard')" :href="route('dashboard')"
                          :active="route().current('dashboard')">
                <template v-slot:icon>
                    <svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" fill="currentColor">
                        <path d="M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z"/>
                    </svg>
                </template>
                <template v-slot:title>Dashboard</template>
            </sidebar-item>
            <sidebar-item v-if="can('view survey list')"
                          :href="$page.props.tenant ? route('tenant.survey.index', $page.props.tenant.id) : route('admin.survey.index')"
                          :active="$page.props.tenant ? route().current('tenant.survey.index', $page.props.tenant.id) : route().current('admin.survey.index')">
                <template v-slot:icon>
                    <svg class="w-5 h-5" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                        <path d="M384 112v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h80c0-35.29 28.71-64 64-64s64 28.71 64 64h80c26.51 0 48 21.49 48 48zM192 40c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24m96 114v-20a6 6 0 0 0-6-6H102a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h180a6 6 0 0 0 6-6z"/>
                    </svg>
                </template>
                <template v-slot:title>My diagnostics</template>
            </sidebar-item>
            <sidebar-item v-if="can('manage users')" :href="route('admin.users.index')"
                          :active="route().current('admin.users.index')">
                <template v-slot:icon>
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                         stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/>
                    </svg>
                </template>
                <template v-slot:title>User Management</template>
            </sidebar-item>
            <sidebar-item :href="route('admin.survey.defaults')"
                                  :active="route().current('admin.survey.defaults')">
                <template v-slot:icon>
                    <svg class="w-5 h-5" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <path d="M487.4 315.7l-42.6-24.6c4.3-23.2 4.3-47 0-70.2l42.6-24.6c4.9-2.8 7.1-8.6 5.5-14-11.1-35.6-30-67.8-54.7-94.6-3.8-4.1-10-5.1-14.8-2.3L380.8 110c-17.9-15.4-38.5-27.3-60.8-35.1V25.8c0-5.6-3.9-10.5-9.4-11.7-36.7-8.2-74.3-7.8-109.2 0-5.5 1.2-9.4 6.1-9.4 11.7V75c-22.2 7.9-42.8 19.8-60.8 35.1L88.7 85.5c-4.9-2.8-11-1.9-14.8 2.3-24.7 26.7-43.6 58.9-54.7 94.6-1.7 5.4.6 11.2 5.5 14L67.3 221c-4.3 23.2-4.3 47 0 70.2l-42.6 24.6c-4.9 2.8-7.1 8.6-5.5 14 11.1 35.6 30 67.8 54.7 94.6 3.8 4.1 10 5.1 14.8 2.3l42.6-24.6c17.9 15.4 38.5 27.3 60.8 35.1v49.2c0 5.6 3.9 10.5 9.4 11.7 36.7 8.2 74.3 7.8 109.2 0 5.5-1.2 9.4-6.1 9.4-11.7v-49.2c22.2-7.9 42.8-19.8 60.8-35.1l42.6 24.6c4.9 2.8 11 1.9 14.8-2.3 24.7-26.7 43.6-58.9 54.7-94.6 1.5-5.5-.7-11.3-5.6-14.1zM256 336c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"/>
                    </svg>
                </template>
                <template v-slot:title>My organisation settings</template>
            </sidebar-item>
            <sidebar-item :href="route('admin.survey.templates.index')"
                                  :active="route().current('admin.survey.templates.index')">
                <template v-slot:icon>
                    <svg class="w-5 h-5" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                        <path d="M384 112v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h80c0-35.29 28.71-64 64-64s64 28.71 64 64h80c26.51 0 48 21.49 48 48zM192 40c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24m96 114v-20a6 6 0 0 0-6-6H102a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h180a6 6 0 0 0 6-6z"/>
                    </svg>
                </template>
                <template v-slot:title>Survey Templates</template>
            </sidebar-item>
<!--            <sidebar-submenu v-if="canAny(['manage survey settings','manage survey templates'])" :active="isSurveySettingRoute">-->
<!--                <template v-slot:icon>-->
<!--                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"-->
<!--                         stroke="currentColor">-->
<!--                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"-->
<!--                              d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z"/>-->
<!--                    </svg>-->
<!--                </template>-->
<!--                <template v-slot:title>Survey Settings</template>-->
<!--                <template v-slot:submenuItems>-->
<!--                    <sidebar-submenu-item :href="route('admin.survey.defaults')"-->
<!--                                          :active="route().current('admin.survey.defaults')">-->
<!--                        <template v-slot:icon>-->
<!--                            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"-->
<!--                                 xmlns="http://www.w3.org/2000/svg">-->
<!--                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"-->
<!--                                      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>-->
<!--                            </svg>-->
<!--                        </template>-->
<!--                        <template v-slot:title>Survey Options</template>-->
<!--                    </sidebar-submenu-item>-->
<!--                    <sidebar-submenu-item :href="route('admin.survey.templates.index')"-->
<!--                                          :active="route().current('admin.survey.templates.index')">-->
<!--                        <template v-slot:icon>-->
<!--                            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"-->
<!--                                 xmlns="http://www.w3.org/2000/svg">-->
<!--                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"-->
<!--                                      d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>-->
<!--                            </svg>-->
<!--                        </template>-->
<!--                        <template v-slot:title>Survey Templates</template>-->
<!--                    </sidebar-submenu-item>-->
<!--                </template>-->
<!--            </sidebar-submenu>-->
        </ul>
        <!--        <div class="px-6 my-6">-->
        <!--            <button-->
        <!--                class="flex items-center justify-between w-full px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-purple-600 border border-transparent rounded-lg active:bg-purple-600 hover:bg-purple-700 focus:outline-none focus:shadow-outline-purple"-->
        <!--            >-->
        <!--                Create account-->
        <!--                <span class="ml-2" aria-hidden="true">+</span>-->
        <!--            </button>-->
        <!--        </div>-->
    </div>
</template>

<script>
import SidebarSubmenu from "@/Jetstream/SidebarSubmenu";
import SidebarSubmenuItem from "@/Jetstream/SidebarSubmenuItem";
import SidebarItem from "@/Jetstream/SidebarItem";
import ApplicationLogo from "@/Jetstream/ApplicationLogo";
import {computed} from "vue";

export default {
    name: "Sidebar",
    components: {
        ApplicationLogo,
        SidebarItem,
        SidebarSubmenu,
        SidebarSubmenuItem,
    },
    setup() {
        const isSurveySettingRoute = computed(() => {
            return [
                'admin.survey.defaults',
                'admin.survey.templates.index',
            ].includes(route().current())
        });

        return {
            isSurveySettingRoute,
        }
    }
}
</script>

<style scoped>

</style>
